<!-- <iframe src="http://localhost:4200/preview" #iframe (load)="onLoad(iframe)">
        <ng-container *ngIf="(editState === 'editing' || editState === 'updated');else loading">
</iframe> -->
<div class="display-container scrollable-container">
    <ng-container *ngIf="(editState === 'editing' || editState === 'updated');else loading">
        <iframe [src]="sanitizedPreviewUrl" #iframe (load)="onLoad(iframe)">
        
        </iframe>
    </ng-container>
    <ng-template #loading>
        <div class="loading-container">
            <div>Loading</div>
        </div>
    </ng-template>
    
</div>

